export interface UserNote {
  id: number;
  text: string;
  color: string;
  isPinned: boolean;
  createdAt: string;
  updatedAt: string;
}

export const NOTE_COLORS = [
  { value: '#fef08a', label: 'Yellow' },
  { value: '#bbf7d0', label: 'Green' },
  { value: '#bfdbfe', label: 'Blue' },
  { value: '#fecaca', label: 'Red' },
  { value: '#e9d5ff', label: 'Purple' },
];

export const NOTES_WIDGET_ENABLED_KEY = 'notesWidgetEnabled';
